import React from 'react';

export interface TestManagerShortcutsPanelProps {
  isVisible: boolean;
  onClose: () => void;
  onShow: () => void;
}

export const TestManagerShortcutsPanel: React.FC<TestManagerShortcutsPanelProps> = ({
  isVisible,
  onClose,
  onShow,
}) => (
  <>
    {isVisible && (
      <div className="fixed bottom-4 right-4 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-sm text-gray-600 dark:text-gray-300 z-50 border border-gray-200 dark:border-slate-600 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-semibold text-gray-900 dark:text-white text-lg flex items-center gap-2">
            <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            Skróty klawiszowe
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 p-1 hover:bg-gray-100 dark:hover:bg-slate-600 rounded-lg transition-all duration-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-3">
            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Statusy</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">p</span>
                <span className="text-gray-600 dark:text-gray-300">Passed</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">f</span>
                <span className="text-gray-600 dark:text-gray-300">Failed</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">b</span>
                <span className="text-gray-600 dark:text-gray-300">Blocked</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">n</span>
                <span className="text-gray-600 dark:text-gray-300">Not Tested</span>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Nawigacja</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">→</span>
                <span className="text-gray-600 dark:text-gray-300">Następny test</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">←</span>
                <span className="text-gray-600 dark:text-gray-300">Poprzedni test</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">esc</span>
                <span className="text-gray-600 dark:text-gray-300">Zamknij test/notatki</span>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Notatki</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">t</span>
                <span className="text-gray-600 dark:text-gray-300">Dodaj notatki</span>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Akcje</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">ctrl + d</span>
                <span className="text-gray-600 dark:text-gray-300">Duplikuj test</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">ctrl + e</span>
                <span className="text-gray-600 dark:text-gray-300">Edytuj test</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="font-mono bg-gray-100 dark:bg-slate-600 px-2 py-1 rounded-lg border border-gray-200 dark:border-slate-500 text-gray-700 dark:text-gray-200">h</span>
                <span className="text-gray-600 dark:text-gray-300">Ukryj/pokaż skróty</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )}

    {!isVisible && (
      <button
        onClick={onShow}
        className="fixed bottom-4 right-4 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm rounded-2xl shadow-xl p-3 text-sm text-gray-600 dark:text-gray-300 z-50 border border-gray-200 dark:border-slate-600 hover:bg-gray-50 dark:hover:bg-slate-700 transition-all duration-200"
        title="Pokaż skróty klawiszowe (h)"
      >
        <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </button>
    )}
  </>
);
